"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRoleEnum = void 0;
const profile_schemas_1 = require("../schemas/customer/profile.schemas");
exports.UserRoleEnum = Object.fromEntries(profile_schemas_1.UserRoleSchema.options.map((role) => [role, role]));
